module.exports = __webpack_public_path__ + "static/media/AKC2.0c4c3e9d.png";